<template>
  <div class="pagejoin">
    <Nav />

    <div class="banner">
      <img src="@/assets/img/banner3-joinus.jpg" alt="" />
      <div class="banner-p">
        <div class="wa">{{ $t("Careers.bannerT2") }}</div>
        <div class="xian" v-if="$t('language.name') == 'En'"></div>
      </div>
    </div>
    <div class="searchbox">
      <Search @onSearch="onSearch" />
    </div>

    <div class="wapper col2panl">
      <div class="tree">
        <Tree @onResult="onResult" />
      </div>
      <div class="panleright">
        <div class="empty" v-if="list.length == 0">暂无相关职位!</div>
        <div class="reslist">
          <template v-for="(item, i) in list">
            <Item :key="i" :row="item" />
          </template>
        </div>

        <div class="PaginationBox">
          <Pagination
            :index="pageIndex"
            :size="pageSize"
            :total="total"
            @indexChange="indexChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "../nav";
import Search from "./Search";
import Item from "./Item";
import Tree from "./Tree";
import { GetPositionList } from "@/api/api";
import Pagination from "@/components/Pagination";
export default {
  components: {
    Nav,
    Search,
    Item,
    Pagination,
    Tree,
  },
  data() {
    return {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      list: [],

      filter:{
        name: "",
        type: -1
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    indexChange(idx) {
      this.pageIndex = idx;
      this.getData();
    },

    onSearch(kw){
      this.filter.name = kw;;
      this.getData();
    },

    onResult(par) {
      console.log(par);
      this.filter = Object.assign(this.filter, par);
      this.getData();
    },

    getData() {
      var { pageIndex, pageSize } = this;
      var pars = {
        pageIndex, pageSize ,
      }
      pars = Object.assign(pars, this.filter);
      GetPositionList(pars).then((res) => {
        console.log(res);
        var { code, data } = res;

        if (code === 0) {
          var { dataCount } = data || {};
          var list = data.data || [];
          this.list = list;
          this.total = dataCount;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pagejoin {
  background-color: #f8f8f8;
}

.searchbox {
  position: relative;
  width: 650px;
  height: 56px;
  margin: 0 auto;
  transform: translateY(-28px);
}

.banner {
  width: 100%;
  height: 387px;
  display: flex;
  position: relative;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  img {
    height: 100%;
  }
  .banner-p {
    width: 1260px;
    height: 70px;
    position: absolute;
    top: 158px;
    left: 50%;
    margin-left: -630px;
    padding-left: 80px;
    box-sizing: border-box;

    .wa {
      float: left;
      font-style: normal;
      font-weight: 500;
      font-size: 44px;
      line-height: 70px;
      color: #fff;
    }
    .xian {
      float: left;
      background: #fff;
      width: 90px;
      height: 2px;
      margin-top: 34px;
      margin-left: 50px;
    }
  }
}

.col2panl {
  display: flex;
  width: 1260px;
  min-height: 600px;

  .empty {
    padding: 60px;
    font-size: 20px;
    color: #1E2026;
    text-align: center;
  }

  .tree {
    flex: 1;
  }
  .panleright {
    width: 860px;
  }
  .PaginationBox {
    display: flex;
    justify-content: flex-end;
    padding: 40px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/join/index.vue